import { Radio, RadioProps, styled } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

// Custom icon component for unchecked state (empty circle)
const UncheckedIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="12" cy="12" r="10" fill="none" stroke={colors.greyPreset[130]} strokeWidth="1.5" />
        </svg>
    );
};

// Custom icon component for checked state (donut shape - thick ring)
const CheckedIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            {/* Thick ring/donut shape - using stroke with large width to create ring effect */}
            <circle cx="12" cy="12" r="8" fill="none" stroke={colors.primaryLight[100]} strokeWidth="7" />
        </svg>
    );
};

const StyledRadio = styled(Radio)({
    padding: 0,
    margin: '0px 8px',
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&.Mui-checked': {
        color: colors.primaryLight[100],
    },
});

type CustomRadioProps = RadioProps;

export const CustomRadio: React.FC<CustomRadioProps> = props => {
    return <StyledRadio {...props} icon={<UncheckedIcon />} checkedIcon={<CheckedIcon />} />;
};
